import { Suspense } from 'react';

import HomeToolLayer from '@/components/HomeToolLayer';
import { HOME_TOOLS } from '@/consts/homeTools';

interface HomeToolPanelProps {
  activeSlug: string;
}

/**
 * Renders every registered home tool (`HOME_TOOLS`) as a keep-alive layer over
 * the feed. Fully generic — a new tool shows up here automatically once added
 * to the registry, with no change to this file.
 */
const HomeToolPanel = ({ activeSlug }: HomeToolPanelProps) => (
  <>
    {HOME_TOOLS.map(({ slug, Content }) => (
      <HomeToolLayer key={slug} isActive={activeSlug === slug}>
        <Suspense fallback={null}>
          <Content />
        </Suspense>
      </HomeToolLayer>
    ))}
  </>
);

export default HomeToolPanel;
